import React from "react";
import { Link } from "react-router-dom";

const SubscribeOne = ({ phone, socials, email , logo}) => {
  const formatPhoneNumber = (number) => {
    // Remove non-numeric characters
    return number.replace(/[^\d]/g, "");
  };
  // Format the phone number
  const formattedNumber = formatPhoneNumber(phone);
  const whatsappURL = `https://wa.me/1${formattedNumber}`;
  return (
    <div className="container">
      <div
        className="footer-top-1 bg-gray"
        style={{ backgroundImage: "url(assets/img/bg/footer-top-bg1-1.png)" }}
      >
        <div className="footer-logo">
          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              style={{ width: "200px", height: "100px", objectFit: "cover" }}
            />
          </Link>
        </div>
        <div className="call-media-wrap">
          <div className="icon">
            <img src="assets/img/icon/phone-1.svg" alt="Logo" />
          </div>
          <div className="media-body">
            <h6 className="title text-white">Requesting A Call:</h6>
            <h4 className="link">
              <a className="text-white" href={whatsappURL} target="_blank">
                {phone}
              </a>
            </h4>
          </div>
        </div>
        <div className="social-btn">
          <a href={`mailto:${email}`}>
            <i className="fa fa-envelope" />
          </a>
          {socials.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className={social.icon} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscribeOne;
